var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "rating-scale-settings" } }, [
    _c("div", { staticClass: "form-field" }, [
      _c(
        "label",
        { staticClass: "form-label", attrs: { for: "field-label" } },
        [_vm._v(_vm._s(_vm.$t("form.fieldLabel")))]
      ),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.ratingScale.fieldLabel,
            expression: "item.ratingScale.fieldLabel",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text", id: "field-label" },
        domProps: { value: _vm.item.ratingScale.fieldLabel },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.ratingScale, "fieldLabel", $event.target.value)
            },
            function ($event) {
              return _vm.setFieldLabel(_vm.item.ratingScale.fieldLabel)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.labelAlignment"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "button-group" }, [
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "left" },
            on: {
              click: function ($event) {
                return _vm.setAlignment("left")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.left")))]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "right" },
            on: {
              click: function ($event) {
                return _vm.setAlignment("right")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.right")) + "\n                ")]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "button",
            class: { active: _vm.align === "top" },
            on: {
              click: function ($event) {
                return _vm.setAlignment("top")
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("form.top")))]
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "checkbox-group" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.defaultAlign,
              expression: "defaultAlign",
            },
          ],
          staticClass: "checkbox",
          attrs: { type: "checkbox", id: "default-align" },
          domProps: {
            checked: Array.isArray(_vm.defaultAlign)
              ? _vm._i(_vm.defaultAlign, null) > -1
              : _vm.defaultAlign,
          },
          on: {
            change: function ($event) {
              var $$a = _vm.defaultAlign,
                $$el = $event.target,
                $$c = $$el.checked ? true : false
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v)
                if ($$el.checked) {
                  $$i < 0 && (_vm.defaultAlign = $$a.concat([$$v]))
                } else {
                  $$i > -1 &&
                    (_vm.defaultAlign = $$a
                      .slice(0, $$i)
                      .concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.defaultAlign = $$c
              }
            },
          },
        }),
        _vm._v(" "),
        _c(
          "label",
          {
            staticClass: "checkbox-label mt-2",
            attrs: { for: "default-align" },
          },
          [_vm._v(_vm._s(_vm.$t("form.setDefault")))]
        ),
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "form-description" }, [
        _vm._v(_vm._s(_vm.$t("form.chooseLabelAlignment"))),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.subLabel1"))),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.ratingScale.subLabelOne,
            expression: "item.ratingScale.subLabelOne",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text" },
        domProps: { value: _vm.item.ratingScale.subLabelOne },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.ratingScale, "subLabelOne", $event.target.value)
            },
            function ($event) {
              return _vm.setSubLabelOne(_vm.item.ratingScale.subLabelOne)
            },
          ],
        },
      }),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "form-field" }, [
      _c("label", { staticClass: "form-label" }, [
        _vm._v(_vm._s(_vm.$t("form.subLabel2"))),
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.item.ratingScale.subLabelTwo,
            expression: "item.ratingScale.subLabelTwo",
          },
        ],
        staticClass: "form-input",
        attrs: { type: "text" },
        domProps: { value: _vm.item.ratingScale.subLabelTwo },
        on: {
          input: [
            function ($event) {
              if ($event.target.composing) {
                return
              }
              _vm.$set(_vm.item.ratingScale, "subLabelTwo", $event.target.value)
            },
            function ($event) {
              return _vm.setSubLabelTwo(_vm.item.ratingScale.subLabelTwo)
            },
          ],
        },
      }),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }